import React, { Component } from "react";
import Data from "../App";
import "./stylesNew.css";
import AppView from "./AppView";
import { List, fromJS, is } from "immutable";
import ScreenView from "./ScreenView";
import VMView from "./VMView";
import CompView from "./CompView";
import UIView from "./UIView";
import StateView from "./StateView";
import { switchMap, map, distinctUntilChanged } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { getSuperType } from "./TypeHelper";

class DataPage2 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    //const data = DisplayData.getInstance();
    //const rootObs = data.getFilteredElements();
    /*this.subscription = Data.getInstance()
      .getCompTemplates()
      .pipe(
        switchMap(templates =>
          Data.getInstance()
            .getSpecs()
            .pipe(map(specs => [specs, templates]))
        )
      )
      .subscribe(specsAndTemps => {
        console.log("new specs loaded ");
        this.setState({
          appId: 1,
          specs: specsAndTemps[0],
          templates: specsAndTemps[1]
        });
      });*/
    const specs = Data.getInstance().getSpecs();
    const app = specs.pipe(map(specs => specs.get(1)));

    this.subscription1 = app
      .pipe(distinctUntilChanged())
      .subscribe(app => this.setState({ app: app }));
    this.subscription2 = combineLatest(
      app.pipe(map(app => app.get("singletons"))),
      specs,
      (singletonIds, specs) => singletonIds.map(id => specs.get(id))
    )
      .pipe(distinctUntilChanged((listOld, list) => is(listOld, list)))
      .subscribe(singletons => {
        console.log("new singletonZ " + singletons);
        this.setState({ singletons: singletons });
      });
    this.subscription3 = combineLatest(
      app.pipe(map(app => app.get("screens"))),
      specs,
      (screenIds, specs) => screenIds.map(id => specs.get(id))
    )
      .pipe(distinctUntilChanged((listOld, list) => is(listOld, list)))
      .subscribe(screens => {
        console.log("new screens " + screens);
        this.setState({ screens: screens });
      });
  }

  componentWillUnmount() {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

  componentDidCatch(error, info) {
    console.log("ERROR " + error + " INFO: " + info);
  }

  resolveView(root, templates) {
    let spec = root.model.spec;
    console.log("resolveView " + spec);
    for (var childIndex in root.children) {
      var child = root.children[childIndex];
      console.log("resolveView child " + child.model.spec);
      let type = getSuperType(child.model.spec.get("type"), templates);
      console.log("resolveView child type " + type);
      if (type === "fragment" || type === "view") {
        spec = spec.mergeDeep({
          childViews: [this.resolveView(child, templates)]
        });
        //spec = spec.updateIn(['childViews'], list => list.push(this.resolveView(child)));
        //console.log("resolveView spec childview " + JSON.stringify(spec));
        /*spec = spec.set(
          "childViews",
          spec.get("childViews").push(this.resolveView(child))
        );*/
      } else if (type === "ui-binding") {
        spec = spec.mergeDeep({ bindings: [child.model.spec] });
        /*spec = spec.set(
          "bindings",
          spec.get("bindings").push(child.model.spec)
        );*/
      } else if (type === "ui-action") {
        spec = spec.mergeDeep({ uiActions: [child.model.spec] });
        /*spec = spec.set(
          "uiActions",
          spec.get("uiActions").push(child.model.spec)
        );*/
      } else if (type === "ui-single-reaction") {
        spec = spec.mergeDeep({ uiSingleActions: [child.model.spec] });
        //spec = spec.updateIn(['uiSingleActions'], list => list.push(child.model.spec));
        /*spec = spec.set(
          "uiSingleActions",
          spec.get("uiSingleActions").push(child.model.spec)
        );*/
      }
    }
    return spec;
  }

  resolveState(rootState, templates) {
    let rootStateSpec = rootState.model.spec;
    //rootStateSpec.childStates = [];
    for (let child of rootState.children) {
      //let child = rootState.children[childIndex];
      let type = getSuperType(child.model.spec.get("type"), templates);
      if (type === "state") {
        rootStateSpec = rootStateSpec.mergeDeep({
          childStates: fromJS([this.resolveState(child, templates)])
        });
        //rootStateSpec.get('childStates').push(this.resolveState(child));
      }
    }
    return rootStateSpec;
  }

  buildModels(root, templates) {
    //console.log("buildModels root: " + root.model.spec);
    var screens = new List();
    var singletons = new List();

    for (let childIndex in root.children) {
      let appChild = root.children[childIndex];
      //console.log("buildModels appChild: " + appChild.model.spec);
      if (
        getSuperType(appChild.model.spec.get("type"), templates) === "activity"
      ) {
        let rootView;
        var vms = new List();
        //screen.vms = [];
        for (let childIndex in appChild.children) {
          let child = appChild.children[childIndex];
          //console.log("buildModels appChild child: " + child.model.spec.get("type"));
          if (
            getSuperType(child.model.spec.get("type"), templates) ===
            "viewmodel"
          ) {
            var streams = new List();
            var stateChangers = new List();
            var rootState;
            for (let childIndex in child.children) {
              let vmChild = child.children[childIndex];
              let vmChildSpec = vmChild.model.spec;
              //console.log("buildModels appChild child vmChild: " + vmChildSpec);
              let vmChildType = getSuperType(
                vmChildSpec.get("type"),
                templates
              );
              if (vmChildType === "stream") streams = streams.push(vmChildSpec);
              else if (vmChildType === "ui-event-stream")
                streams = streams.push(vmChildSpec);
              else if (vmChildType === "stateChanger")
                stateChangers = stateChangers.push(vmChildSpec);
              else if (vmChildType === "state")
                rootState = this.resolveState(vmChild, templates);
            }
            let vm = child.model.spec
              .set("streams", streams)
              .set("stateChangers", stateChangers)
              .set("rootState", rootState);
            //console.log("buildModels appChild child vm: " + vm);
            vms = vms.push(vm);
          } else if (
            getSuperType(child.model.spec.get("type"), templates) ===
              "fragment" ||
            getSuperType(child.model.spec.get("type"), templates) === "view"
          ) {
            rootView = this.resolveView(child, templates);
          }
        }
        //console.log("vms: " + vms);
        let screen = appChild.model.spec
          .set("vms", vms)
          .set("rootView", rootView);
        console.log("screen: " + JSON.stringify(screen));
        screens = screens.push(screen);
      } else if (
        getSuperType(appChild.model.spec.get("type"), templates) === "stream"
      ) {
        singletons = singletons.push(appChild.model.spec);
      }
    }
    let app = root.model.spec
      .set("singletons", singletons)
      .set("screens", screens);
    return app;
  }

  render() {
    let appview = "";
    if (this.state.app) {
      //let specs = this.state.specs;
      //let templates = this.state.templates;
      /*const Streams = ({ streams }) => {
        return !streams
          ? ""
          : streams
            .map(id => specs.get(id))
            .map(stream => {
              console.log("render Stream " + stream);
              let classN = "Stream";
              if (stream.get("type") === "ui-event-stream")
                classN = "UiEventStream";
              return (
                <span key={stream.get("id")} className={classN}>
                  {stream.get("name")}
                </span>
              );
            });
      };
      const StateChangers = ({ stateChangers }) => {
        return !stateChangers
          ? ""
          : stateChangers
            .map(id => specs.get(id))
            .map(stateChanger => (
              <span key={stateChanger.get("id")} className="StateChanger">
                {stateChanger.get("name")}
              </span>
            ));
      };
      const RootState = ({ state }) => {
        return !state ? "" : <StateView stateId={state} specs={specs} />;
      };
      const Vms = ({ vmIds }) => {
        return !vmIds
          ? ""
          : vmIds
            .map(id => specs.get(id))
            .map(vm => (
              <VMView key={vm.get("id")} vm={vm}>
                <div className="Streams">
                  <Streams streams={vm.get("streams")} />
                </div>
                <div className="StateChangers">
                  <StateChangers stateChangers={vm.get("stateChangers")} />
                </div>
                <div className="States">
                  <RootState state={vm.get("rootState")} />
                </div>
              </VMView>
            ));
      };*/
      function getScreens(screens) {
        return !screens
          ? ""
          : screens.map(screen => {
              console.log("screen: " + JSON.stringify(screen));
              return (
                <ScreenView key={screen.get("id")} screen={screen}>
                  <div className="Views">
                    {!screen.get("rootView") ? (
                      ""
                    ) : (
                      <CompView
                        compId={screen.get("rootView")}
                        screenId={screen.get("id")}
                      />
                    )}
                  </div>
                </ScreenView>
              );
              /*return (
              <ScreenView key={screen.get("id")} screen={screen}>
                <Vms vmIds={screen.get("vms")} />
                <br />
                <div className="Views">
                  <RootView
                    viewId={screen.get("rootView")}
                    screenId={screen.get("id")}
                  />
                </div>
              </ScreenView>
            );*/
            });
      }
      function getSingletons(singletons) {
        console.log("getSingletons " + singletons);
        return !singletons
          ? ""
          : singletons.map(singletonId => {
              return <CompView key={singletonId} compId={singletonId} />;
            });
      }
      appview = (
        <AppView app={this.state.app}>
          <div className="Singletons">
            {getSingletons(this.state.app.get("singletons"))}
          </div>
          <div className="Screens">{getScreens(this.state.screens)}</div>
        </AppView>
      );
      /*appview = (
        specs.get(this.state.appId).get("screens")
          .map(id => specs.get(id))
          .map(screen => {
            console.log("screen: " + JSON.stringify(screen));
            return (
              <ScreenView key={screen.get("id")} screen={screen}>
                  {screen.get("rootView") ? <CompView compId={screen.get("rootView")} screenId={screen.get("id")} /> : ""}
                </ScreenView>
            );
          })
      );*/
    }
    return (
      <div>
        <div>{appview}</div>
      </div>
    );
  }
}

export default DataPage2;



// WEBPACK FOOTER //
// ./src/components/DataPage2.js